<section>
    <div class="page-title">
        <h2>{{ planData.title }}</h2>
        <a class="xm-btn-link-light description-link" *ngIf="pageData.headerLink" [uiSref]="pageData.headerLinkUiSref"
            [uiParams]="headerLinkParams">{{ pageData.headerLink }}</a>
    </div>
    <div class="content">
        <h3>{{ pageData.header }}</h3>

        <div class="flex-container">
            <div class="image-primary">
                <xm-media-image [imageOptions]="imagePrimary" size="width"></xm-media-image>
            </div>
            <div class="feature-content">
                <div class="feature-list" *ngFor="let feature of features">
                    <xm-media-image [imageOptions]="feature.imageOption" size="height" class="icons"></xm-media-image>
                    <div class="feature-details">
                        <cms-text class="feature-description" [originalText]="feature.description"></cms-text>
                    </div>
                </div>
            </div>
        </div>
        <div class="action">
            <cms-text class="description-link" *ngIf="!cimaCore.isBusinessUser && pageData.actionLinkLabel" [originalText]="pageData.actionLinkLabel">
            </cms-text>
            <cms-text class="description-link" *ngIf="cimaCore.isBusinessUser && isCBMInternationalReteLinkEnabled && pageData.cbmactionLinkLabel" [originalText]="pageData.cbmactionLinkLabel | xmEnvLink">
            </cms-text>
        </div>
        <div class="disclaimer">
            {{ pageData.disclaimer }}
        </div>
    </div>

    <xm-add-remove-pass-cards *ngIf="!isLoading" [lines]="lines" [pageData]="pageData.addRemovePass" [action]="intent" [addonLines]="getAddonLines()"
        (passSelectionChange)="handlePassSelectionChange($event)">
    </xm-add-remove-pass-cards>

    <div class="action" *ngIf="getAddonLines().length > 0 && !isLoading">
        <button *ngIf="pageData.secondaryLinkLabel" class="xm-btn-link-light left-btn" (click)="onCancel()">{{
            pageData.secondaryLinkLabel }}</button>
        <button 
            class="xm-btn-primary-light" 
            [ngClass]="{ 'disabled': !enableNextButton }"
            (click)="onClickPrimary()" 
            [disabled]="!enableNextButton">
            {{ pageData.primaryBtnLabel }}
        </button>
    </div>

    <div *ngIf="isLoading">
        <xm-loader-overlay type="card"></xm-loader-overlay>
    </div>

    <div class="support-section">
        <p class="support-header">
            {{ pageData.supportHeader }}
        </p>
        <ng-container *ngIf="isMexCan">
            <div class="support-links" *ngFor="let link of mexCanSupportLinks">
                <xm-decorated-text class="xm-btn-link-light" [inputString]="link"></xm-decorated-text>
            </div>
        </ng-container>

        <ng-container *ngIf="isGTP">
            <div class="support-links" *ngFor="let supportLink of gtpSupportLinks">
                <xm-decorated-text class="xm-btn-link-light" [ngClass]="{ 'support-modal' :supportLink.isModal }"
                    [inputString]="supportLink.link" (click)="launchPayAsYouGoModal(supportLink)"></xm-decorated-text>
            </div>
        </ng-container>
    </div>
</section>
